import { flatMap, groupBy, memoize } from "lodash";

export const GroupByRadioType = memoize((MatchingFields) => {
  const groupedRadio = groupBy(MatchingFields, (item) => {
    if (item.element.ElsRecord.Type === "RadioButton") {
      return item.PannelNo;
    } else {
      return "others";
    }
  });
  const flatenArray = flatMap(groupedRadio, (value, key) => {
    if (key === "others") {
      return value;
    } else {
      return [value];
    }
  });
  return flatenArray;
});
